var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isHide && _vm.showNavigation,
      expression: "!isHide&&showNavigation"
    }],
    staticClass: "component-navigation-btn",
    class: {
      'is-swiper': _vm.type == 2,
      'is-bar': _vm.type == 3 || _vm.type == 4
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm.type == 3 || _vm.type == 4 ? _c('span', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('span', {
    staticClass: "btn-navigation btn-back",
    on: {
      "click": _vm.goBack
    }
  }), _vm.type != 3 ? _c('span', {
    staticClass: "btn-navigation btn-menu",
    on: {
      "click": function click($event) {
        _vm.showMenu = !_vm.showMenu;
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "menu-content",
    class: {
      'is-show': _vm.showMenu
    }
  }, [_c('div', {
    staticClass: "arrow-content"
  }), _c('div', {
    staticClass: "menu-list"
  }, [_c('div', {
    staticClass: "menu-item menu-mall",
    on: {
      "click": function click($event) {
        return _vm.goPage(1);
      }
    }
  }, [_vm._v("商城")]), _c('div', {
    staticClass: "menu-item menu-order",
    on: {
      "click": function click($event) {
        return _vm.goPage(2);
      }
    }
  }, [_vm._v("订单中心")])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };